export default __webpack_public_path__ + "static/media/dashboard.6c6ab5cb.svg";